// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1onH4","left":"StickyBox_left__1S0mG","right":"StickyBox_right__1vd54"};